import React, { useState, useEffect, useRef } from 'react';
import StorageManager from '../context/StorageManager';
import { Card, Alert, Form, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link, useParams, useNavigate} from 'react-router-dom';
import { useProvider, Toast } from '../context/MenuProvider';
import RenderizarItem from '../components/Utils/RenderizarProduto';
import AOS from "aos";
import 'aos/dist/aos.css';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");


const Backup = () => {
    const navigate = useNavigate();
    const {
      hasPerms,
      setTitle,
      crud,
      auth,
      API_BASE_URL,
    } = useProvider();
    const [backup, setBackup] = useState(auth?.backup);
    const [formErrors, setFormErrors] = useState([]);
    const { id } = useParams();
    const { patch, post, get, del, loading } = crud || {};
    
    setTitle("Backup dos dados");
    
    const handleSubmit = async(e)=> {
      if(e) e.preventDefault();
      try{
        const methodForm = backup?.id ? patch : post;
        const response = await methodForm(backup, `/core/backup/${backup?.id?`${backup?.id}/`:''}`);
        if (response?.length){
          Toast.fire({
            icon: "success",
            title: `Backup programado`
          });
          setBackup(response[0]);
        }
      }catch(err){
        alert(JSON.stringify(err.response))
      }
    }
    
    const handleManual = async(e)=> {
      if(e) e.preventDefault();
      try{
        await post({}, `/core/backup/backup/`);
        Toast.fire({
            icon: "success",
            title: `Backup iniciado`
        });
      }catch(err){
        alert(JSON.stringify(err.response))
      }
      setBackup((prev) => ({
        ...prev,
        data_ultimo: new Date().toLocaleString('sv-SE'),
      }));
    }
    
    useEffect(() => {
      const hoje = backup?.data_ultimo ? new Date(backup.data_ultimo) : new Date();
      const proximo = new Date(hoje);
    
      if (backup?.horario) {
        const [hora, minuto] = backup.horario.split(':').map(Number);
        proximo.setHours(hora, minuto, 0, 0);
      }
    
      if (backup?.intervalo) {
        switch (backup.intervalo) {
          case 'diario':
            proximo.setDate(proximo.getDate() + 1);
            break;
          case 'semanal':
            proximo.setDate(proximo.getDate() + 7);
            break;
          case 'mensal':
            proximo.setMonth(proximo.getMonth() + 1);
            break;
          default:
            break;
        }
    
        setBackup((prev) => ({
          ...prev,
          data_proximo: proximo.toLocaleString('sv-SE'),
        }));
      }
    }, [backup?.data_ultimo, backup?.intervalo, backup?.horario, backup?.ativo]);
    
    return (<>
              <Card>
                <Card.Body>
                  <p>O backup dos dados será gerado em planilha Excel e enviada em anexo no email {auth?.email || `cadastrado`}</p>
                  <p>
                    Último backup:{" "}
                    {backup?.arquivo && (
                      <a
                        href={`${API_BASE_URL}${backup?.arquivo}`}
                        className="btn btn-sm btn-outline-dark"
                      >
                        <i className="bx bx-data"></i> Baixar Backup
                      </a>
                    )}{" "}
                    <br />
                    {backup?.data_ultimo
                      ? dayjs(backup?.data_ultimo).format("DD/MM/YYYY [às] HH:mm dddd")
                      : `Nunca`}
                  </p>
                  <p>Próximo backup:<br /> {(backup?.data_proximo && backup?.ativo) ? dayjs(backup?.data_proximo).format("DD/MM/YYYY [às] HH:mm dddd"):`${backup?.ativo?'Indefinido':'Desativado'}`}</p>
                  
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
              
                        <Form.Group controlId="formIntervalo" className="mt-3">
                          <div className="input-group">
                            <span className="input-group-text">Intervalo</span>
                            <Form.Control
                              as="select"
                              value={backup?.intervalo}
                              onChange={(e) => 
                                setBackup((prev)=>({
                                  ...prev,
                                  intervalo:e.target.value
                                }))
                              }
                            >
                              <option value=""></option>
                              <option value="diario">Diário</option>
                              <option value="semanal">Semanal</option>
                              <option value="mensal">Mensal</option>
                            </Form.Control>
                          </div>
                        </Form.Group>
              
                        <Form.Group controlId="formHorario" className="mt-3">
                          <div className="input-group">
                            <span className="input-group-text">Horário</span>
                            <Form.Control
                              type="time"
                              value={backup?.horario || ``}
                              onChange={(e) => {
                                  setBackup((prev)=>({
                                    ...prev,
                                    horario:e.target.value
                                  }));
                              }}
                            >
                            </Form.Control>
                            {formErrors.horario && <Alert variant="danger">{formErrors.horario}</Alert>}
                          </div>
                          <small className="text-danger">Obs: Horário ideal para backup é entre 00:00 (meia noite) e 05:00 da manhã</small>
                        </Form.Group>
                        <Form.Group controlId="formAtivo" className="my-3">
                          <Form.Check
                            type="switch"
                            label="Ativo"
                            checked={backup?.ativo}
                            onChange={(e) =>
                              setBackup((prev) =>({
                                ...prev,
                                ativo:e.target.checked
                              }))
                            }
                          />
                        </Form.Group>
                        <Button variant="outline-dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            Salvar alterações
                        </Button>
                        {backup?.id && (
                          <Button variant="outline-dark" className="mt-4 w-100" onClick={handleManual} disabled={loading}>
                              Fazer backup manual
                          </Button>
                        )}
                    </Form>
                    
                </Card.Body>
            </Card>
    </>)
};

export default Backup;